import { cn } from '../../utils/cn/cn';

const Skeleton = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => (
  <div className={cn('bg-color-skeleton animate-pulse rounded-md', className)} {...props} />
);

export { Skeleton };
